<template>
  <div class="page-tab transaction-container" style="height: 540px">
    <SchemaTablePage
      ref="tablePageRef"
      layout-mode="dialog"
      :form-props="{ labelPosition: 'left' }"
      :immediate="false"
      :search-schema="searchSchema"
      :columns="tableColumns"
      :table-attrs="tableAttrs"
      :default-query="defaultQuery"
      :request="request"
      :build-params="buildParams"
      :parse-result="parseResult"
    >
      <template #table-header>
        <div class="total-stats">
          <div class="total-stats-item">
            <span>总下注</span>
            <span class="total-stats-value">{{ formatAmount(stats.bet_amount_total) }}</span>
          </div>
          <div class="total-stats-item">
            <span>总输赢</span>
            <span class="total-stats-value">{{ formatAmount(stats.win_amount_total) }}</span>
          </div>
          <span class="total-update-time">(最后更新时间{{ formatTimestamp(stats.bet_info_updated_at) }})</span>
        </div>
      </template>
      <template #winAmount="{ row }">
        <span :class="(row.win_amount || 0) >= 0 ? 'text-positive' : 'text-negative'">
          {{ (row.win_amount || 0) >= 0 ? '+' : '' }}{{ formatAmount(row.win_amount) }}
        </span>
      </template>
      <template #betAmount="{ row }">{{ formatAmount(row.bet_amount) }}</template>
      <template #createdAt="{ row }">{{ formatTimestamp(row.created_at) }}</template>
      <template #betStatus="{ row }">
        <el-tag size="mini" :type="formatStatus(row) === 'Win' ? 'success' : 'danger'">{{ formatStatus(row) }}</el-tag>
      </template>
      <template #betId="{ row }">{{ row.bet_id != null ? String(row.bet_id) : '--' }}</template>
    </SchemaTablePage>
  </div>
</template>

<script>
import { getBetList } from '@/api/finance/moneyManagement'
import SchemaTablePage from '@/components/SchemaTablePage'
import { centsToYuan } from '@/utils/amount'
import { formatTimestamp, toUnixSeconds } from '@/utils/time'

const DEFAULT_STATS = Object.freeze({ bet_amount_total: 0, win_amount_total: 0 })

export default {
  name: 'ManageTransactionInfoTabV2',
  components: { SchemaTablePage },
  props: {
    resetKey: { type: Number, default: 0 },
    targetInfo: { type: Object, default: () => ({}) },
    isActive: { type: Boolean, default: false },
  },
  data() {
    return {
      defaultQuery: {
        timeRange: [],
        gameName: '',
        betId: '',
        status: '',
      },
      searchSchema: [
        { prop: 'gameName', label: '游戏名称', component: 'input', componentProps: { clearable: true } },
        { prop: 'betId', label: '注单号', component: 'input', componentProps: { clearable: true } },
        {
          prop: 'status',
          label: '状态',
          component: 'select',
          componentProps: { clearable: true },
          options: [
            { label: '全部', value: '' },
            { label: 'Win', value: 'Win' },
            { label: 'Lose', value: 'Lose' },
          ],
        },
        {
          prop: 'timeRange',
          label: '下注时间',
          component: 'datetime-range',
          componentProps: { clearable: true },
          span: { xs: 24, sm: 12, md: 16, lg: 6, xl: 6 },
        },
        { component: 'actions' },
      ],
      tableColumns: [
        { resizable: false, prop: 'game_title', label: '游戏名称', minWidth: 150 },
        { resizable: false, prop: 'game_id', label: '游戏编号', minWidth: 100 },
        { resizable: false, prop: 'win_amount', label: '输赢情况', minWidth: 100, slot: 'winAmount' },
        { resizable: false, prop: 'bet_amount', label: '下注金额', minWidth: 100, slot: 'betAmount' },
        { resizable: false, prop: 'created_at', label: '下注时间', width: 150, slot: 'createdAt' },
        { resizable: false, prop: 'status', label: '状态', width: 80, align: 'center', slot: 'betStatus' },
        { resizable: false, prop: 'bet_id', label: '注单号', minWidth: 140, showOverflowTooltip: true, slot: 'betId' },
      ],
      stats: { ...DEFAULT_STATS },
      summaryColumns: ['win_amount', 'bet_amount'],
      currentStatusFilter: '',
      tableAttrs: {
        showSummary: true,
        summaryMethod: this.getSummaries,
      },
    }
  },
  computed: {
    request() {
      return params => getBetList(params)
    },
    buildParams() {
      return ({ query, page, limit }) => {
        this.currentStatusFilter = query?.status || ''
        const username = this.targetInfo?.username
        return {
          page,
          page_size: limit,
          username,
          bet_id: query?.betId || '',
          game_id: '',
          game_title: query?.gameName || '',
          inviter_username: '',
          inviter_uid: 0,
          start_time: query?.timeRange?.length === 2 ? toUnixSeconds(query.timeRange[0]) || 0 : 0,
          end_time: query?.timeRange?.length === 2 ? toUnixSeconds(query.timeRange[1]) || 0 : 0,
        }
      }
    },
    parseResult() {
      return response => {
        if (response && response.code === 0 && response.data) {
          this.stats = response.data.stats || { ...DEFAULT_STATS }
          const list = response.data.list || []
          const status = this.currentStatusFilter
          const filteredList = !status ? list : list.filter(row => this.formatStatus(row) === status)
          return {
            list: filteredList,
            total: response.data.total || 0,
          }
        }
        this.stats = { ...DEFAULT_STATS }
        this.$message.error(response?.msg || response?.message || '加载投注记录失败')
        return { list: [], total: 0 }
      }
    },
  },
  mounted() {
    if (this.targetInfo?.username) {
      this.$nextTick(() => this.$refs.tablePageRef?.reload?.())
    }
  },
  watch: {
    resetKey() {
      this.$nextTick(() => this.$refs.tablePageRef?.reset?.())
    },
  },
  methods: {
    formatTimestamp,
    formatAmount(v) {
      if (v == null) return '0'
      return centsToYuan(v)
    },
    formatStatus(row) {
      const win = row.win_amount || 0
      return win > 0 ? 'Win' : 'Lose'
    },
    getSummaries(param) {
      console.log('getSummaries', param)
      const { columns, data } = param
      const sums = []
      columns.forEach((col, idx) => {
        if (idx === 0) {
          sums[idx] = '投注分数小计（当前页）'
          return
        }
        if (this.summaryColumns.includes(col.property)) {
          const values = data.map(item => Number(item[col.property]) || 0)
          const s = values.reduce((a, b) => a + b, 0)
          sums[idx] = s ? centsToYuan(s) : 0
        } else {
          sums[idx] = ''
        }
      })
      return sums
    },
  },
}
</script>

<style lang="scss" scoped>
.total-stats {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  .total-stats-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-weight: 700;
    color: #555;
    .total-stats-value {
      font-weight: 700;
      // font-size: 14px;
    }
  }
  .total-update-time {
    font-size: 12px;
    color: #999;
  }
}
.text-positive {
  color: #67c23a;
  font-weight: 500;
}
.text-negative {
  color: #f56c6c;
  font-weight: 500;
}
</style>
